import moment from "moment";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface FilterType {
  coa: string[]
  start_date: string
  end_date: string
  location_id: string
}


type FilterStore = {
  filter: FilterType;
  setFilter: {
    (updater: Partial<FilterType>): void;
    (updater: (prev: FilterType) => FilterType): void;
  };
};

export const useStoreFillter = create<FilterStore>()(
  persist(
    (set) => ({
      filter: {
        coa: [],
        start_date: moment().startOf("year").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        location_id: "0",
        coa_name: "",
      },
      setFilter: (updater) =>
        set((state) => {
          if (typeof updater === "function") {
            return { filter: updater(state.filter) };
          }
          return { filter: { ...state.filter, ...updater } };
        }),
      resetFilter: () =>
        set({
          filter: {
            coa: [],
            start_date: moment().startOf("year").format("YYYY-MM-DD"),
            end_date: moment().format("YYYY-MM-DD"),
            location_id: "0",
          },
        }),
    }),
    {
      name: "filter-storage-coa",
    }
  )
);